import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// --- Interfaces ---
import type { ICategories, ICategory } from '@interfaces/category';

export interface ICategoriesState extends ICategories {}

export const INITIAL_STATE: ICategoriesState = {
	metadata: {
		page: 0,
		pageLimit: 0,
		count: 0,
	},
	result: [],
};

@Injectable({
	providedIn: 'root',
})
export class CategoriesStore {
	private _categoriesState = new BehaviorSubject<ICategoriesState>(
		INITIAL_STATE
	);

	readonly categoriesState$ = this._categoriesState.asObservable();

	constructor() {}

	updateCategories(categories: ICategoriesState) {
		const state = this._categoriesState.value;

		const data = {
			...state,
			...categories,
		};

		this._categoriesState.next(data);

		return this._categoriesState.asObservable();
	}

	updateCategory(category: ICategory) {
		const state = this._categoriesState.value;

		const categoryIndex = state.result.findIndex(
			({ id }) => id === category.id
		);

		if (categoryIndex >= 0) {
			state.result[categoryIndex] = {
				...state.result[categoryIndex],
				...category,
			};
		} else {
			state.result.push(category);
		}

		const data = state;

		this._categoriesState.next(data);

		return this._categoriesState.asObservable();
	}

	deleteCategory(category: ICategory) {
		const state = this._categoriesState.value;

		const categoryIndex = state.result.findIndex(
			({ id }) => id === category.id
		);

		state.result.splice(categoryIndex, 1);

		const data = state;

		this._categoriesState.next(data);

		return this._categoriesState.asObservable();
	}
}
